import {ControlValueAccessor} from '@angular/forms';
import {ElementRef, EventEmitter, HostBinding, Injector, Input, Output, ViewChild} from '@angular/core';

export abstract class AbstractInput implements ControlValueAccessor {
    @Input() public autocomplete: string;
    @Output() public clicked$: EventEmitter<Event>;
    @HostBinding('class.disabled') @Input() public disabled: boolean;
    @Input() public errors: any;
    @HostBinding('class.focussed') public focussed: boolean;
    @Input() public hint: string;
    @ViewChild('input', {static: false}) public input: ElementRef;
    public id: string;
    @Input() public name: string;
    @Input() public pattern: string;
    @Input() public placeholder: string;
    @Input() public required: boolean;
    @Input() public title: string;
    protected _value: any;

    constructor(protected injector: Injector) {
        this.clicked$ = new EventEmitter<Event>();
        this.id = Math.random().toString();
        this.placeholder = 'N/A';
        this.title = 'N/A';
    }

    /**
     *
     */
    public blur(): void {
        this.focussed = false;
    }

    /**
     *
     * @param _
     */
    public changed = (_: any) => {
    };

    /**
     *
     */
    public focus(): void {
        this.focussed = true;
    }

    /**
     * Propagate the change to the FormGroup
     * @param fn
     */
    public registerOnChange(fn: any): void {
        this.changed = fn;
    }

    /**
     * Register the FormControl is dirty and has been
     * "touched" by the user
     * @param fn
     */
    public registerOnTouched(fn: any): void {
        this.touched = fn;
    }

    /**
     *
     * @param disabled
     */
    public setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
    }

    /**
     *
     * @param _
     */
    public touched = (_: any) => {
    };

    /**
     * Return the private member that holds
     * the current model value
     */
    public get value(): any {
        return this._value;
    }

    /**
     * Set the model value if it is not the same
     * as it currently is, also register a change
     * @param value
     */
    public set value(value: any) {
        if (value !== this._value) {
            this._value = value;
            this.changed(this._value);
        }
    }

    /**
     * Initial value write on construction
     * @param value
     */
    public writeValue(value: any): void {
        this.value = value;
    }
}
